// @react/hooks/useTaskTemplate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { taskTemplateStore } from '@core/stores';

/**
 * React hook for TaskTemplate operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useTaskTemplate } from '@react/hooks';
 *
 * const TaskTemplateList = observer(() => {
 *   const store = useTaskTemplate();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useTaskTemplate() {
  return taskTemplateStore;
}
